import React from 'react'
import styles from './FullName.module.css'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { useStepContext } from '../../../Context/StepContext'
import { useAbTestGtm } from '../../../utils/abTest'

export const FullName: React.FC = () => {
    const {
        formData,
        updateFormData,
        errors,
        touchField,
        touchedFields
    } = useStepContext()

    const handleLastNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateFormData('lastName', e.target.value)
    }

    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateFormData('firstName', e.target.value)
    }

    const handleAgeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateFormData('age', e.target.value)
    }

    const handleBlur = (field: 'lastName' | 'firstName' | 'age') => {
        touchField(field)
    }

    const showLastNameError = touchedFields.lastName && errors.lastName
    const showFirstNameError = touchedFields.firstName && errors.firstName
    const showAgeError = touchedFields.age && errors.age

    const isFormValid =
        !errors.lastName &&
        !errors.firstName &&
        !errors.age &&
        formData.lastName &&
        formData.firstName &&
        formData.age
    
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                <BackButton dataClickLabel={dataClickLabel('EF_StepForm_Step4-名前年齢-戻る')} />
                <h1
                    data-view-label={dataViewLabel('EF_StepForm_Step4-名前年齢')}
                    className={styles.titleText}
                >
                    Q.基本情報は？
                </h1>
            </div>

            <div className={styles.formContainer}>
                <div className={styles.inputRow}>
                    <div className={styles.inputField}>
                        <div className={styles.labelWrapper}>
                            <label className={styles.label}>姓</label>
                            <span className={styles.required}>必須</span>
                        </div>
                        <input
                            type='text'
                            autoComplete='family-name'
                            className={`${styles.textInput} ${showLastNameError ? styles.inputError : ''}`}
                            value={formData.lastName}
                            onChange={handleLastNameChange}
                            onBlur={() => handleBlur('lastName')}
                            placeholder='山田'
                        />
                        {showLastNameError && (
                            <div className={styles.errorMessage}>{errors.lastName}</div>
                        )}
                    </div>

                    <div className={styles.inputField}>
                        <div className={styles.labelWrapper}>
                            <label className={styles.label}>名</label>
                            <span className={styles.required}>必須</span>
                        </div>
                        <input
                            type='text'
                            autoComplete='given-name'
                            className={`${styles.textInput} ${showFirstNameError ? styles.inputError : ''}`}
                            value={formData.firstName}
                            onChange={handleFirstNameChange}
                            onBlur={() => handleBlur('firstName')}
                            placeholder='太郎'
                        />
                        {showFirstNameError && (
                            <div className={styles.errorMessage}>{errors.firstName}</div>
                        )}
                    </div>
                </div>

                <div className={styles.inputRow}>
                    <div className={styles.inputField}>
                        <div className={styles.labelWrapper}>
                            <label className={styles.label}>年齢</label>
                            <span className={styles.required}>必須</span>
                        </div>
                        <input
                            type='number'
                            className={`${styles.textInput} ${showAgeError ? styles.inputError : ''}`}
                            value={formData.age}
                            onChange={handleAgeChange}
                            onBlur={() => handleBlur('age')}
                            placeholder='20'
                            min='1'
                            max='99'
                        />
                        {showAgeError && (
                            <div className={styles.errorMessage}>{errors.age}</div>
                        )}
                    </div>
                </div>
            </div>

            <NextButton
                disabled={!isFormValid}
                dataClickLabel={dataClickLabel('EF_StepForm_Step4-名前年齢-次へ')}
            />
        </div>
    )
}